export const DEFAULT = "F001";
export const PLANING = "F002";
export const PLANING_CONFIRM = "F002_CONFIRM";
export const PLANING_ERROR = "F002_ERROR";
export const PLANING_WARNING = "F002_WARNING";
export const STATUS = "F003";
export const ADVANCEMENT = "ADVANCEMENT";

export const PAGE_CHUNKS = [DEFAULT, PLANING, STATUS];

export const STEPS = [
  ...PAGE_CHUNKS,
  ADVANCEMENT,
  PLANING_CONFIRM,
  PLANING_ERROR,
  PLANING_WARNING,
];
